import mykhailoPhoto from "@assets/image_1773345523383.png";
import { useSEO } from "@/hooks/use-seo";
import { PaymentLogoPill } from "@/components/PaymentLogoPill";
import { useState } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import {
  ArrowRight, Star, CheckCircle, XCircle, ShieldCheck, Gamepad2,
  HeadphonesIcon, Info, Heart, CreditCard, ChevronDown, ChevronUp,
  Clock, Mail, MessageCircle, Globe, Calendar, Lock, Users, Trophy,
  Zap, AlertTriangle
} from "lucide-react";
import { Button } from "@/components/ui/button";
import logo9 from "@assets/logos_extracted/9.png";
import { CasinoBreadcrumb } from "@/components/CasinoBreadcrumb";
import { DalsiRecenze } from "@/components/DalsiRecenze";

const CASINO_URL = "https://stnvgs.fynkelto.com/?mid=308616_1816138";

const tabs = [
  { id: "platby",     label: "Platby",              icon: CreditCard },
  { id: "hry",        label: "Hry",                 icon: Gamepad2 },
  { id: "podpora",    label: "Zákaznická podpora",  icon: HeadphonesIcon },
  { id: "obecne",     label: "Obecné informace",    icon: Info },
  { id: "zodpovedne", label: "Zodpovědné hraní",    icon: Heart },
];

const depositMethods = [
  "Mastercard", "Paysafecard", "Skrill", "Nuvei", "Neteller",
  "Jetonbank", "MiFinity", "USDT TRC20", "USDT ERC20", "USDT BEP20",
  "Bitcoin", "Ethereum", "Litecoin", "Solana", "BNB",
  "Ripple", "Bitcoin Cash", "Dogecoin", "Cardano",
];

const withdrawalMethods = [
  "Visa", "Mastercard", "Bank Transfer", "Revolut", "Skrill",
  "Nuvei", "Neteller", "Jetonbank", "MiFinity", "USDT TRC20",
  "USDT ERC20", "USDT BEP20", "Bitcoin", "Ethereum", "Litecoin",
  "Solana", "BNB", "Ripple", "Bitcoin Cash", "Dogecoin", "Cardano",
];

const pros = [
  "Bohatá nabídka více než 7 500 her od předních výrobců",
  "Uvítací bonus 100 % až do 12 500 Kč + 200 free spinů + 1 Bonus Crab",
  "Podpora v češtině dostupná 24/7 přes live chat",
  "Pohodlné platební metody včetně karet, e-peněženek a kryptoměn",
  "Rychlá registrace a mobilně optimalizované prostředí",
];

const cons = [
  "Vysoké požadavky na protočení bonusu (35× vklad + bonus, 40× free spiny)",
  "Měsíční limity výběrů se liší podle platební metody",
];

function TabContent({ activeTab }: { activeTab: string }) {
  const rowClass = "flex flex-col sm:flex-row sm:items-start gap-1 py-3 border-b border-[#eef1f7] last:border-0";
  const labelClass = "text-gray-500 text-sm sm:w-44 flex-shrink-0";
  const valueClass = "text-gray-900 text-sm font-medium leading-relaxed";

  if (activeTab === "platby") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Minimální vklad:</span><span className={valueClass}>250 Kč</span></div>
        <div className={rowClass}><span className={labelClass}>Minimální výběr:</span><span className={valueClass}>250 Kč</span></div>
        <div className={rowClass}><span className={labelClass}>Rychlost výplat:</span><span className={valueClass}>1–2 dny</span></div>
        <div className={rowClass}><span className={labelClass}>Měsíční limit výběru:</span><span className={valueClass}>175 000 Kč (VIP hráči vyšší)</span></div>
        <div className={rowClass}><span className={labelClass}>Poplatky:</span><span className={valueClass}>Žádné ze strany kasina</span></div>
        <div className={rowClass}>
          <span className={labelClass}>Metody vkladu:</span>
          <span className={valueClass}>Mastercard, Paysafecard, Skrill, Nuvei, Neteller, Jetonbank, MiFinity, Bitcoin, Ethereum, Litecoin, Tether, Ripple, Dogecoin a další kryptoměny</span>
        </div>
        <div className={rowClass}>
          <span className={labelClass}>Metody výběru:</span>
          <span className={valueClass}>Visa, Mastercard, bankovní převod, Revolut, Skrill, Nuvei, Neteller, Jetonbank, MiFinity, kryptoměny</span>
        </div>
      </div>
    );
  }
  if (activeTab === "hry") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Počet her:</span><span className={valueClass}>Více než 7 500 titulů</span></div>
        <div className={rowClass}><span className={labelClass}>RTP:</span><span className={valueClass}>94–97 % (standard trhu)</span></div>
        <div className={rowClass}><span className={labelClass}>Výherní automaty:</span><span className={valueClass}>Ano – klasické, jackpoty, Megaways</span></div>
        <div className={rowClass}><span className={labelClass}>Živé kasino:</span><span className={valueClass}>Ano – ruleta, blackjack, baccarat s krupiéry</span></div>
        <div className={rowClass}><span className={labelClass}>Sportovní sázení:</span><span className={valueClass}>Ano</span></div>
        <div className={rowClass}><span className={labelClass}>eSports:</span><span className={valueClass}>Ano</span></div>
        <div className={rowClass}><span className={labelClass}>Stírací losy:</span><span className={valueClass}>Ano</span></div>
        <div className={rowClass}><span className={labelClass}>Video poker:</span><span className={valueClass}>Ano</span></div>
        <div className={rowClass}><span className={labelClass}>Klíčoví poskytovatelé:</span><span className={valueClass}>Pragmatic Play, NetEnt, Evolution, Play&apos;n GO, Playtech, Microgaming, Yggdrasil</span></div>
      </div>
    );
  }
  if (activeTab === "podpora") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Pracovní doba:</span><span className={valueClass}>Dostupné 24/7</span></div>
        <div className={rowClass}><span className={labelClass}>Živý chat:</span><span className={valueClass}>Ano – v češtině</span></div>
        <div className={rowClass}><span className={labelClass}>E-mail:</span><span className={valueClass}>Ano</span></div>
        <div className={rowClass}><span className={labelClass}>Telefonická podpora:</span><span className={valueClass}>Ne</span></div>
      </div>
    );
  }
  if (activeTab === "obecne") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Web:</span><span className={valueClass}><a href="https://stonevegas.com" target="_blank" rel="sponsored noopener noreferrer" className="text-[#003da5] hover:underline">stonevegas.com</a></span></div>
        <div className={rowClass}><span className={labelClass}>Rok založení:</span><span className={valueClass}>2026</span></div>
        <div className={rowClass}><span className={labelClass}>Provozovatel:</span><span className={valueClass}>NovaForge Ltd</span></div>
        <div className={rowClass}><span className={labelClass}>Licence:</span><span className={valueClass}>Anjouan (Gaming Board of Anjouan)</span></div>
        <div className={rowClass}><span className={labelClass}>Jazyky:</span><span className={valueClass}>Čeština, Angličtina, Němčina, Španělština, Finština, Francouzština, Maďarština, Norština, Polština, Italština a další</span></div>
        <div className={rowClass}><span className={labelClass}>Mobilní hraní:</span><span className={valueClass}>Mobilně optimalizovaný web</span></div>
      </div>
    );
  }
  if (activeTab === "zodpovedne") {
    const items: [string, string][] = [
      ["Limit vkladu:", "Ano"],
      ["Limit sázek:", "Ano"],
      ["Sebevyloučení:", "Ano"],
      ["KYC ověření:", "Povinné při výběrech"],
      ["Demo režim:", "Ano"],
      ["VIP program:", "Ano – cashback, vyšší limity"],
    ];
    return (
      <div className="divide-y divide-[#eef1f7]">
        {items.map(([label, value]) => (
          <div key={label} className={rowClass}>
            <span className={labelClass}>{label}</span>
            <span className={`${valueClass} ${value === "Ano" ? "text-green-600" : value === "Ne" ? "text-gray-400" : "text-gray-900"}`}>{value}</span>
          </div>
        ))}
      </div>
    );
  }
  return null;
}

export default function StoneVegasPage() {
  useSEO({ title: "Stone Vegas Recenze 2026 – Retro Vegas styl a bonus | HrajBonus", description: "Recenze Stone Vegas Casino. Retro Vegas styl, velký výběr slotů a bonus pro nové hráče. Rychlé výplaty, zákaznická podpora 24/7. 18+",
  url: "https://hrajbonus.com/kasina/stone-vegas", });

  const [activeTab, setActiveTab] = useState("platby");
  const [showAllDeposit, setShowAllDeposit] = useState(false);
  const [showAllWithdrawal, setShowAllWithdrawal] = useState(false);

  const depositVisible = showAllDeposit ? depositMethods : depositMethods.slice(0, 10);
  const withdrawalVisible = showAllWithdrawal ? withdrawalMethods : withdrawalMethods.slice(0, 10);

  return (
    <>
      <Header />
      <main className="bg-[#f7f9fd] min-h-screen pt-[64px]">

        {/* ── Hero ─────────────────────────────────────────── */}
        <div style={{ background: "linear-gradient(135deg, #001a4d 0%, #002d7c 50%, #003da5 100%)" }}>
          <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-10 sm:py-14">
            <div className="flex flex-col lg:flex-row lg:items-center gap-8 lg:gap-12">

              <div className="flex-1">
                <div className="flex items-center gap-6 mb-5">
                  <div className="w-[100px] h-[100px] rounded-xl flex-shrink-0 overflow-hidden shadow-lg">
                    <img src={logo9} alt="Stone Vegas logo" className="w-full h-full object-cover" />
                  </div>
                  <div>
                    <div className="text-white/60 text-sm font-medium mb-0.5">Recenze kasina</div>
                    <h1 className="text-white font-bold text-2xl sm:text-3xl leading-tight">Kasina Stone Vegas</h1>
                    <div className="text-white/50 text-xs mt-0.5">Aktualizováno: 15/02/2026</div>
                  </div>
                </div>

                <div className="flex items-center gap-2 mb-5">
                  <div className="flex gap-0.5">
                    {[1,2,3,4].map(i => (
                      <Star key={i} className="w-5 h-5 fill-[#f5c518] text-[#f5c518]" />
                    ))}
                    <div className="relative w-5 h-5">
                      <Star className="w-5 h-5 text-[#f5c518]/30 absolute inset-0" />
                      <div className="overflow-hidden absolute inset-0" style={{ width: "60%" }}>
                        <Star className="w-5 h-5 fill-[#f5c518] text-[#f5c518]" />
                      </div>
                    </div>
                  </div>
                  <span className="text-white font-bold text-xl">9.1</span>
                  <span className="text-white/50 text-sm">/10</span>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                  {[
                    { label: "Počet her",        value: "7 500+" },
                    { label: "Minimální vklad",  value: "250 Kč" },
                    { label: "Minimální výběr",  value: "250 Kč" },
                    { label: "Licence",          value: "Anjouan" },
                  ].map(s => (
                    <div key={s.label} className="bg-white/10 rounded-lg px-3 py-2.5 backdrop-blur-sm">
                      <div className="text-white/55 text-xs mb-0.5">{s.label}</div>
                      <div className="text-white font-bold text-sm">{s.value}</div>
                    </div>
                  ))}
                </div>

                <div className="mt-3 text-white/50 text-xs font-medium">
                  Přijímá hráče z České republiky
                </div>
              </div>

              <div className="lg:w-[320px] bg-white/10 border border-white/20 rounded-2xl p-6 backdrop-blur-sm">
                <div className="text-center mb-4">
                  <div className="text-white/70 text-sm mb-1">Uvítací bonus</div>
                  <div className="text-white font-black text-2xl leading-tight">až 12 500 Kč</div>
                  <div className="text-[#f5c518] font-bold text-lg">+ 200 Freespiny</div>
                </div>
                <a href={CASINO_URL} target="_blank" rel="sponsored noopener noreferrer" className="block">
                  <Button
                    className="hraj-btn w-full font-bold text-base py-3 gap-2"
                    style={{ background: "#ffffff", color: "#003da5" }}
                    data-testid="button-hero-cta"
                  >
                    Hraj <ArrowRight className="hraj-arrow w-4 h-4" />
                  </Button>
                </a>
                <p className="text-white/40 text-xs text-center mt-3 leading-relaxed">
                  18+ | Zodpovědné hraní | Platí podmínky
                </p>
              </div>
            </div>
          </div>
        </div>

                <CasinoBreadcrumb casinoName="Stone Vegas" />

<div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-8 sm:py-12">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-10">

            <div className="flex-1 min-w-0 space-y-8">

              {/* Author opinion */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm" data-testid="author-opinion">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0"><img src={mykhailoPhoto} alt="Mykhailo Romaenko" className="w-full h-full object-cover" /></div>
                  <div>
                    <div className="font-bold text-gray-900 text-sm">Mykhailo Romaenko</div>
                    <div className="text-gray-400 text-xs">Senior Content Writer</div>
                  </div>
                  <div className="ml-auto text-right">
                    <div className="text-[#003da5] font-black text-xl">9.1</div>
                    <div className="text-gray-400 text-xs">/10 hodnocení</div>
                  </div>
                </div>
                <h2 className="font-bold text-gray-900 text-base mb-2">Názory našich autorů</h2>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Stone Vegas Casino je online kasino provozované společností NovaForge Ltd., které vstoupilo na trh v roce 2026. Kasino funguje na základě licence vydané Gaming Board of Anjouan. Tato licence umožňuje mezinárodní působnost, zároveň však vyžaduje férové podmínky hraní, výplácení výher a ochranu hráčů. Provozovatel má zkušenosti s více online kasiny a díky tomu může Stone Vegas nabídnout moderní herní prostředí, pohodlné platební metody, rychlou registraci a zákaznickou podporu dostupnou 24/7. Kasino cílí i na české hráče, pro které připravilo lokalizované prostředí a atraktivní bonusy.
                </p>

                <div className="grid sm:grid-cols-2 gap-4 mt-5">
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-green-700 text-xs uppercase tracking-wide mb-2">
                      <CheckCircle className="w-3.5 h-3.5" /> Výhody
                    </div>
                    <ul className="space-y-1.5">
                      {pros.map(p => (
                        <li key={p} className="flex items-start gap-1.5 text-gray-700 text-sm">
                          <span className="text-green-500 font-bold mt-0.5 flex-shrink-0">+</span> {p}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-red-600 text-xs uppercase tracking-wide mb-2">
                      <XCircle className="w-3.5 h-3.5" /> Nevýhody
                    </div>
                    <ul className="space-y-1.5">
                      {cons.map(c => (
                        <li key={c} className="flex items-start gap-1.5 text-gray-700 text-sm">
                          <span className="text-gray-400 font-bold mt-0.5 flex-shrink-0">▬</span> {c}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              {/* Tabs */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] shadow-sm overflow-hidden" data-testid="casino-overview-tabs">
                <div className="px-5 pt-5 pb-0 border-b border-[#eef1f7]">
                  <h2 className="font-bold text-gray-900 text-base mb-4">Přehled kasina</h2>
                  <div className="flex gap-0 overflow-x-auto scrollbar-hide -mx-5 px-5">
                    {tabs.map(tab => (
                      <button
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        className={`flex items-center gap-1.5 px-3 py-2.5 text-xs font-semibold whitespace-nowrap border-b-2 transition-colors flex-shrink-0 ${
                          activeTab === tab.id
                            ? "border-[#003da5] text-[#003da5]"
                            : "border-transparent text-gray-500 hover:text-gray-700"
                        }`}
                        data-testid={`tab-${tab.id}`}
                      >
                        <tab.icon className="w-3.5 h-3.5" />
                        {tab.label}
                      </button>
                    ))}
                  </div>
                </div>
                <div className="p-5">
                  <TabContent activeTab={activeTab} />
                </div>
              </div>

              {/* Stone Vegas intro */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-black text-gray-900 text-xl sm:text-2xl mb-4">
                  Stone Vegas Casino: Moderní bonusy a bezpečné prostředí pro české hráče
                </h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Stone Vegas Casino je online kasino provozované společností NovaForge Ltd., které vstoupilo na trh v roce 2026. Kasino funguje na základě licence vydané Gaming Board of Anjouan. Tato licence umožňuje mezinárodní působnost, zároveň však vyžaduje férové podmínky hraní, výplácení výher a ochranu hráčů.
                </p>
                <p className="text-gray-600 leading-relaxed">
                  Provozovatel má zkušenosti s více online kasiny a díky tomu může Stone Vegas nabídnout moderní herní prostředí, pohodlné platební metody, rychlou registraci a zákaznickou podporu dostupnou 24/7. Kasino cílí i na české hráče, pro které připravilo lokalizované prostředí a atraktivní bonusy.
                </p>
              </div>

              {/* No-license warning */}
              <div className="bg-amber-50 border border-amber-300 rounded-2xl p-5 flex gap-3" data-testid="license-warning">
                <AlertTriangle className="w-5 h-5 text-amber-600 mt-0.5 flex-shrink-0" />
                <div>
                  <div className="font-bold text-amber-800 text-sm mb-1">Poznámka k licenci</div>
                  <p className="text-amber-700 text-sm leading-relaxed">
                    Stone Vegas provozuje svou činnost na základě licence Gaming Board of Anjouan, nikoli české státní licence Ministerstva financí ČR. Z pohledu českého práva proto nejde o regulovaného operátora v tuzemsku. Vždy si ověřte platné podmínky pro svůj region a hrajte zodpovědně.
                  </p>
                </div>
              </div>

              {/* Games */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Hry a software</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Stone Vegas nabízí více než 7 500 online her, včetně výherních automatů, rulety, blackjacku, baccaratu a živých stolů s krupiéry. Nechybí ani jackpotové hry, stírací losy či video poker.
                </p>
                <p className="text-gray-600 leading-relaxed mb-5">
                  Mezi poskytovateli najdete renomované značky jako Pragmatic Play, NetEnt, Evolution, Play&apos;n GO, Playtech, Microgaming nebo Yggdrasil. RTP se pohybuje v rozmezí 94–97 %, což odpovídá standardu trhu.
                </p>

                <div className="grid sm:grid-cols-2 gap-2 mb-5">
                  {[
                    "Výherní automaty",
                    "Ruleta, blackjack, baccarat",
                    "Živé stoly s krupiéry",
                    "Jackpotové hry",
                    "Stírací losy",
                    "Video poker",
                    "Sportovní sázení",
                    "eSports",
                  ].map(item => (
                    <div key={item} className="flex items-center gap-2 text-gray-600 text-sm">
                      <CheckCircle className="w-4 h-4 text-[#003da5] flex-shrink-0" />
                      {item}
                    </div>
                  ))}
                </div>

                <div className="bg-[#f3f6fb] rounded-xl p-4">
                  <div className="font-bold text-gray-900 text-sm mb-2">Klíčoví poskytovatelé softwaru</div>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    Pragmatic Play, NetEnt, Evolution Gaming, Play&apos;n GO, Playtech, Microgaming, Yggdrasil, Nolimit City, Hacksaw Gaming, Red Tiger Gaming, Big Time Gaming a desítky dalších studií zajišťují rozmanitý a kvalitní katalog.
                  </p>
                </div>
              </div>

              {/* Bonuses */}
              <div id="bonusy" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Bonusy a promoakce</h2>

                <h3 className="font-bold text-gray-900 text-base mb-3">Uvítací bonus</h3>
                <div className="bg-[#f0f5ff] border border-[#003da5]/15 rounded-xl p-4 mb-5">
                  <div className="text-[#003da5] font-black text-xl mb-1">100 % až do 12 500 Kč</div>
                  <div className="text-[#c9960f] font-bold mb-1">+ 200 freespinů + 1 Bonus Crab</div>
                  <div className="text-gray-500 text-xs">Minimální vklad pro aktivaci: 500 Kč</div>
                </div>

                <h3 className="font-bold text-gray-900 text-base mb-3">Jak bonus aktivovat</h3>
                <div className="space-y-2.5 mb-5">
                  {[
                    "Vytvořte účet a ověřte jej.",
                    "V sekci Moje bonusy zvolte uvítací nabídku.",
                    "Proveďte první vklad.",
                    "Bonus a freespiny se připíšou po splnění podmínek.",
                  ].map((step, i) => (
                    <div key={i} className="flex items-start gap-2.5 text-gray-700 text-sm">
                      <span className="text-[#003da5] font-bold flex-shrink-0">{i + 1}.</span> {step}
                    </div>
                  ))}
                </div>

                <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 mb-5">
                  <div className="font-bold text-amber-800 text-sm mb-2">Na co si dát pozor (typické podmínky)</div>
                  <ul className="space-y-1.5">
                    {[
                      "Požadavky na protočení: 35× bonus + vklad, 40× freespiny",
                      "Maximální sázka při protočení: omezená (dle pravidel)",
                      "Časová platnost bonusu a spinů: omezená – sledujte v profilu",
                      "Některé hry a regiony mohou být vyloučeny",
                    ].map(item => (
                      <li key={item} className="flex items-start gap-1.5 text-amber-700 text-xs">
                        <AlertTriangle className="w-3.5 h-3.5 mt-0.5 flex-shrink-0" /> {item}
                      </li>
                    ))}
                  </ul>
                </div>

                <h3 className="font-bold text-gray-900 text-base mb-3">Pravidelné promoakce a VIP</h3>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Po využití uvítací nabídky se hráči mohou těšit na reload bonusy, cashback, turnaje a VIP program s více úrovněmi. VIP výhody zahrnují vyšší měsíční limity a exkluzivní akce.
                </p>
                <div className="grid sm:grid-cols-2 gap-2">
                  {["Reload bonusy", "Cashback", "Turnaje", "VIP program s více úrovněmi", "Vyšší měsíční limity pro VIP", "Exkluzivní akce"].map(item => (
                    <div key={item} className="flex items-center gap-2 text-gray-600 text-sm">
                      <Trophy className="w-4 h-4 text-[#c9960f] flex-shrink-0" />
                      {item}
                    </div>
                  ))}
                </div>
              </div>

              {/* Payments */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Platby</h2>
                <p className="text-gray-600 leading-relaxed mb-5">
                  Kasino podporuje širokou nabídku platebních metod včetně Visa, Mastercard, Paysafecard, Skrill, Neteller, MiFinity, Jeton, Revolut i kryptoměn (Bitcoin, Ethereum, Litecoin, Tether, Ripple, Dogecoin).
                </p>

                <div className="grid sm:grid-cols-2 gap-3 mb-5">
                  {[
                    { label: "Minimální vklad",       value: "250 Kč" },
                    { label: "Minimální výběr",        value: "250 Kč" },
                    { label: "Rychlost výplat",        value: "1–2 dny" },
                    { label: "Měsíční limit výběru",   value: "175 000 Kč (VIP vyšší)" },
                  ].map(({ label, value }) => (
                    <div key={label} className="bg-[#f3f6fb] rounded-xl p-3">
                      <div className="text-gray-500 text-xs mb-0.5">{label}</div>
                      <div className="text-gray-900 font-bold text-sm">{value}</div>
                    </div>
                  ))}
                </div>

                <div className="mb-5">
                  <div className="font-semibold text-gray-800 text-sm mb-2">Metody vkladu</div>
                  <div className="flex flex-wrap gap-1.5">
                    {depositVisible.map(m => (
                      <PaymentLogoPill key={m} name={m} />
                    ))}
                    {depositMethods.length > 10 && (
                      <button onClick={() => setShowAllDeposit(!showAllDeposit)} className="flex items-center gap-1 text-[#003da5] text-xs font-semibold hover:underline">
                        {showAllDeposit ? (<><ChevronUp className="w-3 h-3" /> méně</>) : (<><ChevronDown className="w-3 h-3" /> +{depositMethods.length - 10} dalších</>)}
                      </button>
                    )}
                  </div>
                </div>

                <div>
                  <div className="font-semibold text-gray-800 text-sm mb-2">Metody výběru</div>
                  <div className="flex flex-wrap gap-1.5">
                    {withdrawalVisible.map(m => (
                      <PaymentLogoPill key={m} name={m} />
                    ))}
                    {withdrawalMethods.length > 10 && (
                      <button onClick={() => setShowAllWithdrawal(!showAllWithdrawal)} className="flex items-center gap-1 text-[#003da5] text-xs font-semibold hover:underline">
                        {showAllWithdrawal ? (<><ChevronUp className="w-3 h-3" /> méně</>) : (<><ChevronDown className="w-3 h-3" /> +{withdrawalMethods.length - 10} dalších</>)}
                      </button>
                    )}
                  </div>
                </div>
              </div>

              {/* Pros/Cons summary */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-5">Výhody a nevýhody</h2>
                <div className="grid sm:grid-cols-2 gap-6">
                  <div>
                    <div className="font-bold text-green-700 text-sm mb-3">Plusy</div>
                    <ul className="space-y-2">
                      {[
                        "Více než 7 500 her od top poskytovatelů",
                        "Široká nabídka platebních metod včetně kryptoměn",
                        "Nepřetržitá zákaznická podpora (live chat 24/7 v češtině)",
                        "VIP program s cashbackem a vyššími výběrovými limity",
                      ].map(item => (
                        <li key={item} className="flex items-start gap-2 text-gray-700 text-sm">
                          <span className="text-green-500 font-bold flex-shrink-0">+</span> {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <div className="font-bold text-red-600 text-sm mb-3">Mínusy</div>
                    <ul className="space-y-2">
                      {[
                        "Vysoké požadavky na protočení bonusu",
                        "Minimální vklad pro bonus 500 Kč",
                        "Nabídka eSports her je menší než u konkurence",
                      ].map(item => (
                        <li key={item} className="flex items-start gap-2 text-gray-700 text-sm">
                          <span className="text-gray-400 font-bold flex-shrink-0">▬</span> {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              {/* Support */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Zákaznická podpora</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Zákaznická podpora je dostupná nepřetržitě 24/7 přes live chat v češtině a e-mail. Telefonická linka není k dispozici.
                </p>
                <div className="grid sm:grid-cols-3 gap-3">
                  <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-100 rounded-xl">
                    <MessageCircle className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">Live chat v češtině</div>
                      <div className="text-green-600 text-xs">24/7 dostupný</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-100 rounded-xl">
                    <Mail className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">E-mail</div>
                      <div className="text-green-600 text-xs">Dostupný</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3 p-3 bg-gray-50 border border-gray-200 rounded-xl">
                    <HeadphonesIcon className="w-5 h-5 text-gray-400 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-700 text-sm">Telefon</div>
                      <div className="text-gray-400 text-xs">Není k dispozici</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Safety */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Bezpečnost a licence</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Stone Vegas funguje na základě licence Gaming Board of Anjouan, která zajišťuje mezinárodní standardy férovosti a ochrany hráčů. Provozovatel NovaForge Ltd. má zkušenosti s více online kasiny, což se odráží v kvalitě platformy.
                </p>
                <div className="grid sm:grid-cols-2 gap-2">
                  {[
                    "Licence Gaming Board of Anjouan",
                    "SSL šifrování transakcí",
                    "KYC ověření identity při výběrech",
                    "Limity vkladů a sázek",
                    "Sebevyloučení a odpovědné hraní",
                    "Demo režim pro hru bez rizika",
                  ].map(item => (
                    <div key={item} className="flex items-start gap-2 text-gray-600 text-sm">
                      <ShieldCheck className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                      {item}
                    </div>
                  ))}
                </div>
              </div>

              {/* Author bio */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm" data-testid="author-bio">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0 ring-4 ring-[#003da5]/10"><img src={mykhailoPhoto} alt="Mykhailo Romaenko" className="w-full h-full object-cover" /></div>
                  <div>
                    <div className="font-bold text-gray-900">Mykhailo Romaenko</div>
                    <div className="text-[#003da5] text-sm font-medium">Senior Content Writer</div>
                  </div>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Mykhailo je zkušený autor zaměřený na iGaming, který se dlouhodobě pohybuje v odvětví online hazardu. Má bohatou praxi v psaní článků, které propojují svět hráčů i profesionálů. Jeho specialitou je vytváření hlubokých analýz, přehledných recenzí a trendově orientovaného obsahu, který čtenářům přináší nejen zábavu, ale i znalosti.
                </p>
                <p className="text-gray-600 text-sm leading-relaxed mt-3">
                  Své texty staví na detailním výzkumu a praktické zkušenosti, díky čemuž pomáhá hráčům lépe se orientovat v prostředí online casin.
                </p>
              </div>

            </div>

            {/* ── Sticky sidebar ────────────────────────────── */}
            <aside className="lg:w-[300px] flex-shrink-0">
              <div className="lg:sticky lg:top-[84px] space-y-4">

                <div className="bg-white rounded-2xl border border-[#003da5]/25 shadow-[0_4px_24px_rgba(0,61,165,0.12)] p-5" data-testid="sidebar-cta">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 rounded-lg bg-[#f3f6fb] flex items-center justify-center overflow-hidden">
                      <img src={logo9} alt="Stone Vegas" className="w-full h-full object-cover" />
                    </div>
                    <div>
                      <div className="font-bold text-gray-900 text-sm">Stone Vegas</div>
                      <div className="flex items-center gap-1">
                        {[1,2,3,4].map(i => <Star key={i} className="w-3 h-3 fill-[#f5c518] text-[#f5c518]" />)}
                        <div className="relative w-3 h-3">
                          <Star className="w-3 h-3 text-[#f5c518]/30 absolute inset-0" />
                          <div className="overflow-hidden absolute inset-0" style={{ width: "60%" }}>
                            <Star className="w-3 h-3 fill-[#f5c518] text-[#f5c518]" />
                          </div>
                        </div>
                        <span className="text-gray-600 text-xs ml-1">9.1/10</span>
                      </div>
                    </div>
                  </div>
                  <div className="text-center mb-4 bg-[#f3f6fb] rounded-xl py-3">
                    <div className="text-gray-500 text-xs mb-0.5">Uvítací bonus</div>
                    <div className="text-[#003da5] font-black text-xl">až 12 500 Kč</div>
                    <div className="text-[#c9960f] font-bold text-sm">+ 200 Freespiny</div>
                  </div>
                  <a href={CASINO_URL} target="_blank" rel="sponsored noopener noreferrer" className="block">
                    <Button
                      className="hraj-btn w-full font-bold gap-2"
                      style={{ background: "#003da5" }}
                      data-testid="button-sidebar-cta"
                    >
                      Hraj <ArrowRight className="hraj-arrow w-4 h-4" />
                    </Button>
                  </a>
                  <p className="text-gray-400 text-xs text-center mt-2">18+ | Platí podmínky</p>
                </div>

                <div className="bg-white rounded-2xl border border-[#dde4ee] p-5">
                  <div className="font-bold text-gray-900 text-sm mb-3">Rychlý přehled</div>
                  <div className="space-y-2.5">
                    {([
                      { icon: Globe,      label: "Web",             value: "stonevegas.com" },
                      { icon: Calendar,   label: "Rok",             value: "2026" },
                      { icon: Lock,       label: "Licence",         value: "Anjouan" },
                      { icon: Users,      label: "Provozovatel",    value: "NovaForge Ltd" },
                      { icon: Gamepad2,   label: "Počet her",       value: "7 500+" },
                      { icon: Clock,      label: "Podpora",         value: "24/7 Live chat (CZ)" },
                      { icon: CreditCard, label: "Min. vklad",      value: "250 Kč" },
                      { icon: Zap,        label: "Rychlost výplat", value: "1–2 dny" },
                    ] as const).map(({ icon: Icon, label, value }) => (
                      <div key={label} className="flex items-start gap-2">
                        <Icon className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                        <div className="min-w-0">
                          <span className="text-gray-400 text-xs">{label}: </span>
                          <span className="text-gray-800 font-medium text-xs">{value}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

              </div>
            </aside>

          </div>
        </div>
      </main>
      
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 pb-8">
          <DalsiRecenze currentSlug="stone-vegas" />
        </div>

  
        {/* Related reviews */}
        <div className="max-w-[900px] mx-auto px-4 py-4">
          <p className="text-sm text-gray-500 leading-relaxed text-center">
            <span className="font-semibold text-gray-700">Podobná kasina: </span>
              <a href="/kasina/wazamba" className="text-[#003da5] hover:underline" data-testid="review-link-wazamba">Wazamba</a>
              {" · "}
              <a href="/kasina/alf-casino" className="text-[#003da5] hover:underline" data-testid="review-link-alf-casino">Alf Casino</a>
              {" · "}
              <a href="/kasina/sg-casino" className="text-[#003da5] hover:underline" data-testid="review-link-sg-casino">SG Casino</a>
            {" · "}
            <a href="/kasina" className="text-[#003da5] hover:underline font-semibold" data-testid="review-link-vsechna">Všechna kasina</a>
            {" · "}
            <a href="/porovnat" className="text-[#003da5] hover:underline" data-testid="review-link-porovnat">Porovnání</a>
          </p>
        </div>
      <Footer />
    </>
  );
}
